import React from 'react';
import styled from 'styled-components';

const Cell = styled.span`
  font-weight: 300;
`;

interface IDashboardCellProps {
  dashboard: string;
}
const DashboardCell = ({
  dashboard,
}: IDashboardCellProps) => (
  <Cell>
    {dashboard}
  </Cell>
);

export default DashboardCell;
